import React,{ useRef }from 'react';
import { Container, } from 'react-bootstrap';
import emailjs from 'emailjs-com';
import swal from 'sweetalert';

const Footer = () => {
    const form = useRef();
    const sendEmail = (e) => {
        e.preventDefault();
        emailjs.sendForm('service_ip875kr','template_ayrhad3',form.current, 'user_YtWKLekMd8xU1DuJgGROo')
          .then((result) => {
            swal({
                title: "Thanks For Your Message!",
                text: "I will contact tou soon !!",
                icon: "success",
                button: "Aww yiss!",
              });
          }, (error) => {
              console.log(error.text);
          })
          e.target.reset();
      };
    
    return (
        <div>
            <Container>
                <div id="contact" style={{marginBottom:'60px'}} className='row'>

                 <div className="col-md-6">
                 <h3 className="text-center mt-5" style={{fontSize:"25px",fontWeight:'bold', fontFamily:'cursive'}}>Contact <span style={{fontSize:"25px",fontWeight:'bold',color:'#0FDCDC'}}>Information</span></h3>

                 <div style={{marginTop:'35px'}}>
                 <p style={{fontSize:'17px'}} className="fw-bold"><i style={{fontSize:'25px'}} class="far fa-envelope"></i> hridoysagor506@gmail.com</p>
                 <p style={{fontSize:'17px'}} className="fw-bold"><i style={{fontSize:'25px'}} class="fas fa-mobile-alt"></i> +880 1745934072</p>
                 <a style={{textDecoration:'none',color:'black'}} target='blank' href='https://github.com/hridoy01-hash'><p style={{fontSize:'17px'}} className="fw-bold"><i style={{fontSize:'25px'}} class="fab fa-github"></i> Github</p></a>
                 <a style={{textDecoration:'none',color:'black'}} target='blank' href="https://www.linkedin.com/in/hridoy-ahmed-48a67a143/"><p style={{fontSize:'17px'}} className="fw-bold"><i style={{fontSize:'25px'}} class="fab fa-linkedin"></i> Linkdin</p></a>
                 <p style={{fontSize:'17px'}} className="fw-bold"><i style={{fontSize:'25px'}} class="fas fa-home"></i> Farmgate,Razabazar-1215,Dhaka,Bangladesh</p>
                 </div>
                 </div>

                 <div className="col-md-6">

                 <h3 className="text-center mt-5" style={{fontSize:"20px",fontWeight:'bold', fontFamily:'cursive'}}>GET IN <span style={{fontSize:"20px",fontWeight:'bold',color:'#0FDCDC'}}>TOUCH</span></h3>
                   

            <form ref={form} onSubmit={sendEmail}>
                 <label className='fw-bold'>Enter Name</label>
                <input required className='w-100' type="text" name="fullName" /> <br />
                <label className='mt-3 fw-bold'>Enter Email</label>
                <input required className='w-100'  type="email" name="email" /> <br />
                <label className='mt-3 fw-bold'>Enter Phone Number</label>
                <input required className='w-100' type="number" name="phone" /> <br />
                <label className='mt-3 fw-bold'>Message</label>
                <textarea className='w-100' name="message" />
                <input required className='w-100 btn btn-primary mt-3'  type="submit" value="Send" />
           </form>

                 </div>

                </div>
            </Container>
            <p className="text-center">© Copyright 2021 | Designed By <span className="text-danger">Hridoy Ahmed</span> | All Rights Reserved</p>
        </div>
    );
};

export default Footer;